module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/female_couple-fdf18a2ac676a6a14b0140915ebc1c7d.svg";